// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 배송지 관리 모달 스타일 */
.delivery-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.delivery-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
  position: relative;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 주소 검색 오버레이 */
.address-search-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
  border-radius: 12px;
}

.address-search-container {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80%;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  animation: addressSearchSlideIn 0.2s ease-out;
}

@keyframes addressSearchSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.address-search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
}

.address-search-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.address-search-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.address-search-close:hover {
  background-color: #e9ecef;
  color: #333;
}

.address-search-content {
  width: 100%;
  height: 400px;
  border: none;
}

.delivery-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
}

.delivery-modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.delivery-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.delivery-modal-close:hover {
  background-color: #e9ecef;
  color: #333;
}

.delivery-modal-content {
  padding: 24px;
  max-height: calc(80vh - 80px);
  overflow-y: auto;
}

.delivery-modal-actions {
  margin-bottom: 20px;
  text-align: right;
}

.add-address-btn {
  background-color: #E84100;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.add-address-btn:hover {
  background-color: #d63700;
}

/* 주소 목록 스타일 */
.address-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.address-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  transition: all 0.2s;
}

.address-item:hover {
  border-color: #E84100;
  box-shadow: 0 2px 8px rgba(232, 65, 0, 0.1);
}

.address-info {
  flex: 1 1;
}

.address-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.default-badge {
  background-color: #E84100;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
}

.address-recipient {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.address-phone {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.address-full {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
}

.address-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 16px;
}

.set-default-btn, .delete-address-btn {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid;
  transition: all 0.2s;
  min-width: 60px;
  text-align: center;
}

.set-default-btn {
  background-color: white;
  color: #E84100;
  border-color: #E84100;
}

.set-default-btn:hover {
  background-color: #E84100;
  color: white;
}

.delete-address-btn {
  background-color: white;
  color: #dc3545;
  border-color: #dc3545;
}

.delete-address-btn:hover:not(:disabled) {
  background-color: #dc3545;
  color: white;
}

.delete-address-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 새 주소 추가 폼 스타일 */
.add-address-form h3 {
  margin: 0 0 24px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.form-group input[type="text"],
.form-group input[type="tel"] {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.form-group input[type="text"]:focus,
.form-group input[type="tel"]:focus {
  outline: none;
  border-color: #E84100;
  box-shadow: 0 0 0 3px rgba(232, 65, 0, 0.1);
}

.address-search-group {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.zipcode-input {
  flex: 1 1;
}

.address-search-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  transition: background-color 0.2s;
}

.address-search-btn:hover {
  background-color: #5a6268;
}

.address-input {
  margin-bottom: 8px;
}

.address-detail-input {
  margin-bottom: 0;
}

.checkbox-label {
  display: flex !important;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-bottom: 0 !important;
}

.checkbox-label input[type="checkbox"] {
  margin: 0;
  width: auto;
  cursor: pointer;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.cancel-btn, .save-btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid;
  transition: all 0.2s;
}

.cancel-btn {
  background-color: white;
  color: #6c757d;
  border-color: #6c757d;
}

.cancel-btn:hover {
  background-color: #6c757d;
  color: white;
}

.save-btn {
  background-color: #E84100;
  color: white;
  border-color: #E84100;
}

.save-btn:hover {
  background-color: #d63700;
  border-color: #d63700;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .delivery-modal {
    width: 95%;
    margin: 20px;
  }
  
  .delivery-modal-content {
    padding: 16px;
  }
  
  .address-item {
    flex-direction: column;
    gap: 16px;
  }
  
  .address-actions {
    flex-direction: row;
    margin-left: 0;
    justify-content: flex-start;
  }
  
  .address-search-group {
    flex-direction: column;
  }
  
  .zipcode-input {
    margin-bottom: 8px;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .cancel-btn, .save-btn {
    width: 100%;
  }
  
  .address-search-container {
    width: 95%;
    max-height: 90%;
  }
  
  .address-search-content {
    height: 350px;
  }
}

/* 로딩 및 빈 상태 스타일 */
.loading-message {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-size: 16px;
}

.empty-address-list {
  text-align: center;
  padding: 20px;
}

.empty-address-list p {
  color: #666;
  font-size: 16px;
  margin-bottom: 20px;
}

.user-default-address {
  margin-top: 20px;
  text-align: left;
}

.user-default-address h4 {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}

.default-user-address {
  background-color: #f8f9fa;
  border: 1px dashed #ccc;
}

.default-user-address .address-actions {
  display: none;
} `, "",{"version":3,"sources":["webpack://./src/components/css/DeliveryAddressModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* 배송지 관리 모달 스타일 */\n.delivery-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.delivery-modal {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  animation: modalSlideIn 0.3s ease-out;\n  position: relative;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* 주소 검색 오버레이 */\n.address-search-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1001;\n  border-radius: 12px;\n}\n\n.address-search-container {\n  background: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 80%;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);\n  animation: addressSearchSlideIn 0.2s ease-out;\n}\n\n@keyframes addressSearchSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.address-search-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n}\n\n.address-search-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.address-search-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s;\n}\n\n.address-search-close:hover {\n  background-color: #e9ecef;\n  color: #333;\n}\n\n.address-search-content {\n  width: 100%;\n  height: 400px;\n  border: none;\n}\n\n.delivery-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n}\n\n.delivery-modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n}\n\n.delivery-modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s;\n}\n\n.delivery-modal-close:hover {\n  background-color: #e9ecef;\n  color: #333;\n}\n\n.delivery-modal-content {\n  padding: 24px;\n  max-height: calc(80vh - 80px);\n  overflow-y: auto;\n}\n\n.delivery-modal-actions {\n  margin-bottom: 20px;\n  text-align: right;\n}\n\n.add-address-btn {\n  background-color: #E84100;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.add-address-btn:hover {\n  background-color: #d63700;\n}\n\n/* 주소 목록 스타일 */\n.address-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.address-item {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  transition: all 0.2s;\n}\n\n.address-item:hover {\n  border-color: #E84100;\n  box-shadow: 0 2px 8px rgba(232, 65, 0, 0.1);\n}\n\n.address-info {\n  flex: 1;\n}\n\n.address-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.default-badge {\n  background-color: #E84100;\n  color: white;\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.address-recipient {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 4px;\n}\n\n.address-phone {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 8px;\n}\n\n.address-full {\n  font-size: 14px;\n  color: #333;\n  line-height: 1.4;\n}\n\n.address-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-left: 16px;\n}\n\n.set-default-btn, .delete-address-btn {\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  border: 1px solid;\n  transition: all 0.2s;\n  min-width: 60px;\n  text-align: center;\n}\n\n.set-default-btn {\n  background-color: white;\n  color: #E84100;\n  border-color: #E84100;\n}\n\n.set-default-btn:hover {\n  background-color: #E84100;\n  color: white;\n}\n\n.delete-address-btn {\n  background-color: white;\n  color: #dc3545;\n  border-color: #dc3545;\n}\n\n.delete-address-btn:hover:not(:disabled) {\n  background-color: #dc3545;\n  color: white;\n}\n\n.delete-address-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* 새 주소 추가 폼 스타일 */\n.add-address-form h3 {\n  margin: 0 0 24px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"tel\"] {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group input[type=\"tel\"]:focus {\n  outline: none;\n  border-color: #E84100;\n  box-shadow: 0 0 0 3px rgba(232, 65, 0, 0.1);\n}\n\n.address-search-group {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.zipcode-input {\n  flex: 1;\n}\n\n.address-search-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n}\n\n.address-search-btn:hover {\n  background-color: #5a6268;\n}\n\n.address-input {\n  margin-bottom: 8px;\n}\n\n.address-detail-input {\n  margin-bottom: 0;\n}\n\n.checkbox-label {\n  display: flex !important;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin-bottom: 0 !important;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  margin: 0;\n  width: auto;\n  cursor: pointer;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 32px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.cancel-btn, .save-btn {\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid;\n  transition: all 0.2s;\n}\n\n.cancel-btn {\n  background-color: white;\n  color: #6c757d;\n  border-color: #6c757d;\n}\n\n.cancel-btn:hover {\n  background-color: #6c757d;\n  color: white;\n}\n\n.save-btn {\n  background-color: #E84100;\n  color: white;\n  border-color: #E84100;\n}\n\n.save-btn:hover {\n  background-color: #d63700;\n  border-color: #d63700;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n  .delivery-modal {\n    width: 95%;\n    margin: 20px;\n  }\n  \n  .delivery-modal-content {\n    padding: 16px;\n  }\n  \n  .address-item {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .address-actions {\n    flex-direction: row;\n    margin-left: 0;\n    justify-content: flex-start;\n  }\n  \n  .address-search-group {\n    flex-direction: column;\n  }\n  \n  .zipcode-input {\n    margin-bottom: 8px;\n  }\n  \n  .form-actions {\n    flex-direction: column;\n  }\n  \n  .cancel-btn, .save-btn {\n    width: 100%;\n  }\n  \n  .address-search-container {\n    width: 95%;\n    max-height: 90%;\n  }\n  \n  .address-search-content {\n    height: 350px;\n  }\n}\n\n/* 로딩 및 빈 상태 스타일 */\n.loading-message {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n  font-size: 16px;\n}\n\n.empty-address-list {\n  text-align: center;\n  padding: 20px;\n}\n\n.empty-address-list p {\n  color: #666;\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n\n.user-default-address {\n  margin-top: 20px;\n  text-align: left;\n}\n\n.user-default-address h4 {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 10px;\n  font-weight: 600;\n}\n\n.default-user-address {\n  background-color: #f8f9fa;\n  border: 1px dashed #ccc;\n}\n\n.default-user-address .address-actions {\n  display: none;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
